module.exports = __webpack_public_path__ + "static/media/Shambhu.e35dd617.jpg";